import React, { Component } from 'react';
import { connect } from 'react-redux';
import FormBase from './formBase';
import { formBorrowerProperties } from '../../fixtures/formBorrowerProperties';

const schema = {
  type: 'object',
  required: ['name', 'abn', 'businessName'],
  properties: {
    name: {
      type: 'string',
      title: 'Full name'
    },
    abn: {
      type: 'string',
      title: 'ABN or ACN'
    },
    businessName: {
      type: 'string',
      title: 'Registered business name'
    },
    businessType: {
      type: 'string',
      title: 'Type of business entity',
      enum: ['Sole Proprietor', 'Partnership', 'Public Company', 'Trustee Company', 'Association', 'Pty Ltd', 'Other']
    },
    website: {
      type: 'string',
      title: 'Website (if applicable)'
    },
    outstandingLiabilityPayments: {
      type: 'boolean',
      title: 'Do you the borrower(s) have any outstanding liabilities for taxes or other statutory payments (eg. GST, Group Tax, Superannuation etc)'
    },
    pendingLegalAction: {
      type: 'boolean',
      title: 'Is there any legal action pending or in progress in relation to you, the borrower(s) or the business or which may affect the business (eg. Creditor action, administrator/liquidator appointment etc)',
    },
    capacityToRepay: {
      type: 'boolean',
      title: 'Do the borrower(s) have the capacity to repay all current credit obligations in addition to the proposed obligations as docmented in this application?'
    },
    existingBusinessFacilities: {
      type: 'string',
      title: 'Existing and requested business facilities'
    },
    numberOfEmployees: {
      type: 'integer',
      title: 'Number of employees?'
    },
    businessAddress: {
      title: 'Business address',
      '$ref': '#/definitions/address'
    },
  },
  definitions: {
    address: {
      type: 'object',
      required: [ 'streetAddress', 'city', 'postcode', 'state' ],
      properties: {
        streetAddress: {
          title: 'Street address',
          type: 'string'
        },
        city: {
          title: 'City',
          type: 'string'
        },
        postcode: {
          title: 'Postcode',
          maxLength: 4,
          type: 'string'
        },
        state: {
          title: 'State',
          type: 'string',
          enum: [
            'New South Wales', 'Victoria', 'Queensland', 'Western Australia',
            'South Australia', 'Tasmania', 'Australian Capital Territory', 'Northern Territory'
          ]
        }
      }
    }
  }
};

const uiSchema = {
  purpose: {
    'ui:placeholder': 'Please choose'
  },
  frequency: {
    'ui:placeholder': 'Please choose'
  },
  outstandingLiabilityPayments: {
    'ui:widget': 'radio'
  },
  pendingLegalAction: {
    'ui:widget': 'radio'
  },
  capacityToRepay: {
    'ui:widget': 'radio'
  }
};

const mergedSchema = Object.assign({}, schema, formBorrowerProperties());

class FormBorrowerDetails extends FormBase {
  static defaultProps = { schema: mergedSchema, uiSchema }
}

const connected = connect(() => {})(FormBorrowerDetails);
export default connected;



// WEBPACK FOOTER //
// ./src/containers/Application/formBorrowerDetails.js